
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import ConsultPrepaidTransactionDetailsFormHandler from '@Modules/cardManagementSystem/prepaid/containers/tableHandlers/card/consultPrepaidTransaction/consultPrepaidTransactionDetails/ConsultPrepaidTransactionDetailsFormHandler';
import { useParams } from 'react-router-dom';

export default function ConsultAnonymousCard() {
  const {id} = useParams();
  const oneId = id || 0;
  return (
    <>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Transaction recharge manuelle
        </CC.Text>
        <ConsultPrepaidTransactionDetailsFormHandler id={oneId}/>
      </CC.Box>
    </>
  );
}



